import { Injectable } from '@angular/core'
import { Observable } from "rxjs/Observable"
import { Notification, NotificationService } from 'models'

@Injectable()

export class NotificationInfoService {

  constructor(private notificationService: NotificationService) { }

  notificationsInfo: {
    hasUnread: boolean,
    unreadCount: number
  }
  notifications: Notification[] = []

  loadNotificationsInfo() {
    this.notificationService.unreadedNotificationsInfo().subscribe(
      data => {
        this.notificationsInfo = data['notificationsInfo']
      }
    )
  }

  addNotifications(data: Notification[]) {
    for(let notification of data) {
      if(!this.notifications.find(n => n.id == notification.id)) {
        this.notifications.push(notification)
      }
    }
  }

  notificationRead(id: number): boolean {
    let notification = this.findNotification(id)

    if (notification) {
      return notification.read
    }
  }

  setNotificationRead(id: number, read: boolean) {
    let notification = this.findNotification(id)

    if (notification) {
      notification.read = read
    }
  }

  findNotification(id: number): Notification {
    return this.notifications.find(n => n.id == id)
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/notification_info.service.ts